function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverviewIcon7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 221.37 188.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "overview-icon7-box",
    id: "Rectangle_394",
    "data-name": "Rectangle 394"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.26,188.18h-2.26v-4h2.26c2.59,0,4.98-1.41,6.23-3.69l3.5,1.93c-1.96,3.55-5.69,5.76-9.74,5.76ZM195.99,188.18h-12v-4h12v4ZM171.99,188.18h-12v-4h12v4ZM147.99,188.18h-12v-4h12v4ZM123.99,188.18h-12v-4h12v4ZM99.99,188.18h-12v-4h12v4ZM75.99,188.18h-12v-4h12v4ZM51.99,188.18h-12v-4h12v4ZM27.99,188.18h-12v-4h12v4ZM3.29,184.96C1.17,182.86,0,180.06,0,177.07v-4.8h4v4.8c0,1.91.75,3.7,2.11,5.05l-2.82,2.84ZM221.37,169.65h-4v-12h4v12ZM4,160.27H0v-12h4v12ZM221.37,145.65h-4v-12h4v12ZM4,136.27H0v-12h4v12ZM221.37,121.65h-4v-12h4v12ZM4,112.27H0v-12h4v12ZM221.37,97.65h-4v-12h4v12ZM4,88.27H0v-12h4v12ZM221.37,73.65h-4v-12h4v12ZM4,64.27H0v-12h4v12ZM221.37,49.65h-4v-12h4v12ZM4,40.27H0v-12h4v12ZM221.37,25.65h-4v-12h4v12ZM4,16.27H0v-5.16C0,8.29,1.06,5.6,2.99,3.53l2.92,2.73c-1.23,1.32-1.91,3.04-1.91,4.85v5.16ZM213.87,4.98c-1.09-.64-2.34-.98-3.61-.98h-7.14V0h7.14c1.99,0,3.94.53,5.65,1.54l-2.04,3.44ZM191.11,4h-12V0h12v4ZM167.11,4h-12V0h12v4ZM143.11,4h-12V0h12v4ZM119.11,4h-12V0h12v4ZM95.11,4h-12V0h12v4ZM71.11,4h-12V0h12v4ZM47.11,4h-12V0h12v4ZM23.11,4h-12V0h12v4Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "overview-icon7-symbol",
    d: "M103.72,86.71c-8-7-28.5-23-43.33-23.17s-27.83,15.17-27.83,30.67,16.67,27,26.83,27,23.12-3.67,51.31-28.83c28.19-25.17,41.19-28.83,48.69-28.83s28.83,6.81,28.83,28.99c0,20.18-18.76,28.68-28.67,28.68s-28.89-10.4-43-23",
    style: {
      fill: "none",
      stroke: "#e39f5c",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewIcon7);
export default __webpack_public_path__ + "static/media/overview-icon7.10f6e8b4.svg";
export { ForwardRef as ReactComponent };